//core
import React from "react";
import { useFormikContext, Field } from "formik";
import useDidMountEffect from "../../../../../../../../customHooks/useDidMountEffect";

interface IHelperField {
  values: any;
  baseCurrency: string;
}

const HelperField = (props:IHelperField) => {
  const { values, baseCurrency } = props;

  const {
    setFieldValue,
  } = useFormikContext();

  useDidMountEffect(() => {
    if (!!values.payment_method) {
      if (!!values.payment_method.walletCurrency) {
        setFieldValue('walletCurrency', values.payment_method.walletCurrency);
      } else {
        !values.walletCurrency && setFieldValue('walletCurrency', '');
      }
    }
  }, [values.payment_method, values.walletCurrency]);

  useDidMountEffect(() => {
    if (!!values.payment_method) {
      if (!!values.payment_method.walletCurrency) {
        if (values.payment_method.walletCurrency.toLowerCase() === baseCurrency.toLowerCase()) {
          setFieldValue('walletAmount', values.amount);
        }
      }
    }
  }, [values.payment_method, values.amount]);

  return (
    <>
      <Field hidden />
    </>
  );
};

export default HelperField;
